export default (value, length, canBeEqual = false) => (canBeEqual ? value.length > length : value.length >= length);
